import {type Directive, type DirectiveBinding} from 'vue';

function create(element: HTMLElement, directiveOptions: DirectiveBinding)
{
    element.innerHTML = directiveOptions.value;


    const scripts = Array.from(element.querySelectorAll('script'));
    let i = 0;

    function loadScript(oldScript: HTMLScriptElement)
    {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes)
        .forEach(attr => newScript.setAttribute(attr.name, attr.value));

        if (scripts[i + 1])
        {
            const loadHandler = () => {
                i++;
                loadScript(scripts[i]);
            };

            newScript.onload  = loadHandler;
            newScript.onerror = loadHandler;
        }

        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode && oldScript.parentNode.replaceChild(newScript, oldScript);
    }

    if (scripts.length)
    {
        loadScript(scripts[i]);
    }
}

const htmlScript: Directive = {
    mounted: create,
    updated: create,
};

export default htmlScript;